export const BRISTOL_COORDINATES = { lat: 51.45, lng: -2.59 }
export const ALPHABET = 'abcdefghijklmnopqrstuvwxyz'.toLocaleUpperCase().split('')
export const API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? ''